import { render, staticRenderFns } from "./table-rhp.vue?vue&type=template&id=b120d36e&"
import script from "./table-rhp.vue?vue&type=script&lang=js&"
export * from "./table-rhp.vue?vue&type=script&lang=js&"
import style0 from "./table-rhp.vue?vue&type=style&index=0&id=b120d36e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports